import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import { getCategoryName } from '@/mocks/news';
import { formatViews, timeAgo } from '@/utils/format';

export default function ArticleRow({ article }: { article: NewsArticle }) {
  return (
    <article className="group flex gap-3 border-b border-background-200 py-4 last:border-b-0 md:gap-5">
      <Link
        to={`/detail/${article.id}`}
        className="relative h-20 w-28 shrink-0 overflow-hidden rounded-md md:h-28 md:w-44"
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 911爆料网`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <Link
            to={`/category/${article.category}`}
            className="rounded-md bg-primary-100 px-2 py-0.5 font-medium text-primary-700 transition-colors hover:bg-primary-200"
          >
            {getCategoryName(article.category)}
          </Link>
          {article.hot && (
            <span className="flex items-center gap-1 rounded-md bg-secondary-500 px-2 py-0.5 font-semibold text-background-50">
              <i className="ri-fire-fill"></i>
              热点
            </span>
          )}
          <span className="text-foreground-400">{timeAgo(article.publishedAt)}</span>
        </div>
        <Link to={`/detail/${article.id}`} className="mt-2">
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
            {article.title}
          </h3>
        </Link>
        <p className="mt-1.5 hidden line-clamp-2 text-sm leading-relaxed text-foreground-600 sm:block">
          {article.summary}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-2 text-xs text-foreground-500">
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(article.views)} 阅读
          </span>
          <span className="hidden items-center gap-1 md:flex">
            <i className="ri-price-tag-3-line"></i>
            {article.tags[0]}
          </span>
        </div>
      </div>
    </article>
  );
}